import styles from '../../assets/components/organisms/Field.module.scss'
import { VFC } from 'react'
import { FIELDPROPS } from './types/Field.types'

export const Field: VFC<FIELDPROPS> = ({ fields }) => {
    return (
        <>
            <div className={ styles.field }>
                {
                    fields.map((row: any, index) => {
                        return row.map((column: string) => {
                            if (column === 'snake') {
                                return <div className={ `${styles.dots} ${styles.snake}` }></div>
                            } else if (column === 'food') {
                                return <div className={ `${styles.dots} ${styles.food}` }></div>
                            }
                            return <div className={ styles.dots }></div>
                        })
                    })
                }
            </div>
        </>
    );
}
